var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"config":_vm.config,"visible":_vm.visible,"cancelDialog":_vm.cancelDialog,"confirmDialog":_vm.confirmDialog,"isdeling":_vm.isdeling}},[_c('p',{staticClass:"tips"},[_vm._v(_vm._s(_vm.msg))]),(_vm.explain != '')?_c('p',{staticClass:"tips top"},[_vm._v(" "+_vm._s(_vm.explain)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }